import { BrowserRouter } from "react-router-dom";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { hydrate } from "react-dom";
import { createStoreon } from "storeon";
import { StoreContext } from "storeon/react";
import { storeonDevtools } from "storeon/devtools";
import {
  applyPolyfills,
  defineCustomElements
} from "@garpix/garpix-web-components/loader";
import { storeonParams } from "./store";
import "swiper/swiper-bundle.min.css";
import "@garpix/garpix-web-components/dist/garpix-web-components/garpix-web-components.css";
import App from "./App";

if (process.env.NODE_ENV === "development") {
  storeonParams.push(storeonDevtools);
}

const store = createStoreon(storeonParams);

declare global {
  interface Window {
    UnityLoader?: any;
    PROXY_EVENT_HUB?: any;
  }
}

hydrate(
  <React.StrictMode>
    <StoreContext.Provider value={store}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </StoreContext.Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

applyPolyfills().then(() => {
  defineCustomElements();
});

if (module.hot) {
  module.hot.accept();
}
